import colors from "../../base/colors";
import borders from "../../base/borders";

import rgba from "../../functions/rgba";

const { grey, background } = colors;
const { borderRadius } = borders;

const card = {
  styleOverrides: {
    root: {
      display: "flex" as const,
      flexDirection: "column" as const,
      position: "relative" as const,
      minWidth: 0,
      wordWrap: "break-word" as const,
      backgroundColor: background.card,
      backgroundClip: "border-box" as const,
      border: `1px solid ${rgba(grey[700], 0.8)}`,
      borderRadius: borderRadius.lg,
      boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.3), 0 2px 4px -1px rgba(0, 0, 0, 0.2)",
      overflow: "visible" as const,
      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",

      "&:hover": {
        boxShadow: "0 8px 12px -2px rgba(0, 0, 0, 0.4), 0 4px 6px -2px rgba(0, 0, 0, 0.3)",
        transform: "translateY(-2px)",
        borderColor: rgba(grey[600], 0.8),
      },
    },
  },
};

export default card;
